import { Ionicons } from '@expo/vector-icons';
import React, { useState } from 'react';
import { View } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { AdjustMenuWidgetData, WidgetProps } from './widget-types';
import { WidgetCard } from './widget-card';

const PRIMARY = '#FD5001';

/**
 * Qual parte ele quer ajustar, depois do resumo.
 *
 * Antes, "Ajustar" reabria a entrevista inteira — que olhava o rascunho
 * completo, não tinha nada a perguntar e devolvia o resumo na mesma hora. O
 * botão parecia quebrado. Aqui o toque leva ao cartão exato daquela parte, e
 * quando ele termina o menu volta perguntando se falta mais alguma coisa.
 */
export function AdjustMenuWidget({
  data,
  editable,
  onAdjust,
}: WidgetProps<AdjustMenuWidgetData>) {
  const [picked, setPicked] = useState<string | null>(null);

  // Um toque só: o segundo abriria outro passo por cima do primeiro.
  const locked = !editable || picked !== null;

  return (
    <WidgetCard title={data.title} icon="construct-outline">
      <View className="gap-2">
        {(data.options ?? []).map(option => (
          <PressableScale
            key={option.id}
            disabled={locked}
            onPress={() => {
              setPicked(option.id);
              onAdjust?.({ slot: option.slot }, option.label);
            }}
            className={`flex-row items-center gap-3 rounded-xl border px-3 py-3 ${
              picked === option.id
                ? 'border-primary bg-primary/10'
                : 'border-border/60 bg-neutral-50'
            }`}
          >
            {option.icon ? (
              <Ionicons
                name={option.icon as keyof typeof Ionicons.glyphMap}
                size={17}
                color={picked === option.id ? PRIMARY : '#9ca3af'}
              />
            ) : null}
            <ThemedText className="flex-1 text-sm font-medium text-foreground">
              {option.label}
            </ThemedText>
            <Ionicons className="text-neutral-400" name="chevron-forward" size={15} />
          </PressableScale>
        ))}
      </View>

      <PressableScale
        disabled={locked}
        onPress={() => {
          setPicked('done');
          onAdjust?.({ done: true }, data.doneLabel);
        }}
        className="items-center rounded-full bg-primary py-2.5"
      >
        <ThemedText className="text-sm font-semibold text-white">
          {data.doneLabel}
        </ThemedText>
      </PressableScale>
    </WidgetCard>
  );
}
